import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

type Props = {
  selectedTags: string[];
  onToggleTag: (tag: string) => void;
  onClear: () => void;
};

const SelectedFiltersBar: React.FC<Props> = ({
  selectedTags,
  onToggleTag,
  onClear,
}) => {
  const { t } = useTranslation();

  return (
    <ChipsRow $hasChips={selectedTags.length > 0}>
      <Chips>
        {selectedTags.map((tag) => (
          <Chip
            key={tag}
            onClick={() => onToggleTag(tag)}
            title="Retirer ce filtre"
          >
            {tag} ✕
          </Chip>
        ))}

        {selectedTags.length > 0 && (
          <ClearBtn onClick={onClear}>
            {t("mentalplus_video_renitialiser")}
          </ClearBtn>
        )}
      </Chips>
    </ChipsRow>
  );
};

export default SelectedFiltersBar;

const ChipsRow = styled.div<{ $hasChips: boolean }>`
  background: var(--app-color-background, white);
  padding: ${({ $hasChips }) => ($hasChips ? "0 8px 8px 8px" : "0")};
  min-height: ${({ $hasChips }) => ($hasChips ? "40px" : "0")};
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.button`
  /* Active filter chips = attention -> secondary family (tokens.ts roles). */
  background: var(--app-color-secondary, #ffce48);
  color: var(--app-color-secondary-contrast, #111);
  border: none;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
`;

const ClearBtn = styled.button`
  background: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.08);
  color: var(--app-color-text, #333);
  border: none;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
`;